import React, { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext"
import Layout from "@components/Layout"
import { toast } from "react-hot-toast"
import { db } from "@root/firebase"; // Firebase initialization
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

function Directory() {
  const { globalUser, logout } = useAuth()
  const [loading, setLoading] = useState(true)
  const [directories, setDirectories] = useState([])
  const [activeDirectoryId, setActiveDirectoryId] = useState(null)
  const [activeChild, setActiveChild] = useState(null); // Track selected child directory
  const [editorContent, setEditorContent] = useState(""); // HTML content for editor

  useEffect(() => {
    const fetchDirectories = async () => {
      setLoading(true);
      const q = query(collection(db, "directory"), orderBy("order"));
      const querySnapshot = await getDocs(q);
      const dirs = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDirectories(dirs);
      setLoading(false);
    };
    fetchDirectories();
  }, []);

  const toggleAccordion = (id) => {
    setActiveDirectoryId(activeDirectoryId === id ? null : id);
  }

  const handleChildClick = (child) => {
    setActiveChild(child);
    setEditorContent(child.content || ""); // Load existing content or default to empty
  }

  return (
    <Layout>
      <div className="col-xl-12 col-lg-4">
        <div className="row">
          <div className="col-xl-4 col-lg-4">
            <div className="card">
              <div className="card-header bg-transparent">
                <h5 className="mb-0">Directory Administration</h5>
              </div>
              <div className="p-4 border-top">


                {loading ? (
                  <p>Loading...</p>
                ) : directories.length === 0 ? (
                  <p>No directories found.</p>
                ) : (
                  <ul className="list-unstyled categories-list">
                    {directories
                      .filter((directory) => !directory.parent)
                      .sort((a, b) => a.order - b.order) // Sort parent directories by order
                      .map((directory) => (
                        <li key={directory.id}>
                          <div className="d-flex align-items-center">
                            {/* Main Directory Section */}
                            <div className="col-10">
                              <a
                                className="text-body fw-medium py-1 d-flex align-items-center"
                                data-bs-toggle="collapse"
                                href={`#categories-collapse-${directory.id}`}
                                role="button"
                                aria-expanded={
                                  activeDirectoryId === directory.id
                                }
                                aria-controls={`categories-collapse-${directory.id}`}
                                onClick={() => toggleAccordion(directory.id)}
                              >
                                <i
                                  className={`mdi ${
                                    activeDirectoryId === directory.id
                                      ? "mdi-folder-open"
                                      : "mdi-folder"
                                  } font-size-20 text-warning me-2`} 
                                ></i>
                                {directory.name}
                                <i
                                  className={`mdi ${
                                    activeDirectoryId === directory.id
                                      ? "mdi-chevron-down"
                                      : "mdi-chevron-up"
                                  } ms-auto accor-down-icon`}
                                ></i>
                              </a>
                            </div>
                            
                          </div>

                          {/* Subdirectory Collapse Section */}
                          <div
                            className={`collapse ${
                              activeDirectoryId === directory.id ? "show" : ""
                            }`}
                            id={`categories-collapse-${directory.id}`}
                          >
                            <div className="card border-0 shadow-none ps-2 mb-0">
                              <ul className="list-unstyled mb-0">
                                {directories
                                  .filter(
                                    (subDir) =>
                                      subDir.parent === directory.id
                                  )
                                  .sort((a, b) => a.order - b.order)
                                  .map((subDir) => (
                                    <li
                                      key={subDir.id}
                                      className="d-flex align-items-center mt-2"
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleChildClick(subDir)}
                                    >
                                      <span className="me-auto">
                                      <i
                                        className="fas fa-dog font-size-20 text-dark me-2" 
                                      ></i>
                                        {subDir.name}
                                      </span>
                                      
                                    </li>
                                  ))}
                              </ul>

                              
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-6">
          {activeChild && (
            <div className="card">
              <div className="card-header bg-transparent">
                <h5 className="mb-0">{activeChild.name}</h5>
              </div>
              <div 
                className="p-4"
                dangerouslySetInnerHTML={{
                  __html: editorContent || "No Directory Entry, Coming Soon...",
                }}
              >
              </div>
            </div>
          )}
          </div>

        </div>
      </div>
    </Layout>
  )
}

export default Directory